<template>
  <div>
    <CRow>
      <CCol xs="12" lg="10">
        <CCard>
          <CCardHeader>
            Στοιχεία εταιρείας
          </CCardHeader>
          <CCardBody>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
               <CInput 
                horizontal 
                type="text" 
                label="Επωνυμία Εταιρείας" 
                id="name" 
                placeholder="Επωνυμία Εταιρείας" 
                v-model="name" 
               />
               <CInput 
                horizontal 
                type="text" 
                label="Σλόγκαν" 
                id="motto" 
                placeholder="Σλόγκαν" 
                v-model="motto" 
               />
               <CInput 
                horizontal 
                type="text" 
                label="Σλόγκαν (Αγγλικά)" 
                id="motto_english" 
                placeholder="Σλόγκαν (Αγγλικά)" 
                v-model="motto_english" 
               />
               <div class="form-group form-row">
                  <CCol md="3">
                    <label>Λογότυπο</label>
                  </CCol>
                  <CCol md="9">
                    <CImg :src="logo_url" :block="true" v-if="logoExists" class="logoPreviewImg" />
                    <CButton color="danger" @click="deleteLogo" v-if="logoExists" class="mt-2">Διαγραφή</CButton>
                    <CInputFile
                        type="file"
                        v-on:change="(file) => handleFileUpload(file, 'logo')"
                        placeholder="Προσθέστε αρχείο"
                        v-show="!logoExists"
                      />
                  </CCol>
                </div>
               <div class="form-group form-row">
                  <CCol md="3">
                    <label>Διεύθυνση εταιρείας</label>
                  </CCol>
                  <CCol md="9">
                    <quill-editor v-model="address" :options="editorOption"/>
                  </CCol>
                  <CCol md="3">
                    <label>Διεύθυνση εταιρείας (Αγγλικά)</label>
                  </CCol>
                  <CCol md="9">
                    <quill-editor v-model="address_english" :options="editorOption"/>
                  </CCol>
                </div>
               <CInput 
                horizontal 
                type="text" 
                label="Τηλέφωνο (1)" 
                id="phone_number_1" 
                placeholder="Τηλέφωνο (1)" 
                v-model="phone_number_1" 
               />
               <CInput 
                horizontal 
                type="text" 
                label="Τηλέφωνο (2)" 
                id="phone_number_2" 
                placeholder="Τηλέφωνο (2)" 
                v-model="phone_number_2" 
               />
               <CInput 
                horizontal 
                type="text" 
                label="ΑΦΜ" 
                id="vat" 
                placeholder="ΑΦΜ" 
                v-model="vat" 
               />
               <CInput 
                horizontal 
                type="text" 
                label="ΑΦΜ (Αγγλικά)" 
                id="vat_english" 
                placeholder="ΑΦΜ (Αγγλικά)" 
                v-model="vat_english" 
               />
               <CInput 
                horizontal 
                type="text" 
                label="ΔΟΥ" 
                id="doy" 
                placeholder="ΔΟΥ" 
                v-model="doy" 
               />
               <CInput 
                horizontal 
                type="email" 
                label="Ε-mail" 
                id="email" 
                placeholder="Ε-mail" 
                v-model="email" 
               />
               <CInput 
                horizontal 
                type="text" 
                label="Ιστοσελίδα" 
                id="website" 
                placeholder="Ιστοσελίδα" 
                v-model="website" 
               />
               <div class="form-group form-row">
                  <CCol md="3">
                    <label>Στοιχεία τράπεζας</label>
                  </CCol>
                  <CCol md="9">
                    <quill-editor v-model="bank_accounts" :options="editorOption"/>
                  </CCol>
                  <CCol md="3">
                    <label>Στοιχεία τράπεζας (Αγγλικά)</label>
                  </CCol>
                  <CCol md="9">
                    <quill-editor v-model="bank_accounts_english" :options="editorOption"/>
                  </CCol>
                </div>
                <!-- <div class="form-group form-row">
                  <CCol md="3">
                    <label>Υπογραφή</label>
                  </CCol>
                  <CCol md="9">
                    <CImg :src="signature_url" :block="true" v-if="signatureExists"/>
                    <CButton color="danger" @click="deleteSignature" v-if="signatureExists" class="mt-2">Διαγραφή</CButton>
                    <CInputFile
                        type="file"
                        v-on:change="(file) => handleFileUpload(file, 'signature')"
                        placeholder="Προσθέστε αρχείο"
                        v-show="!signatureExists"
                      />
                  </CCol>
                </div> -->
               <CButton color="primary" class="float-right" @click="update()">Αποθήκευση</CButton>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </diV>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

export default {
  name: 'CompanyInfo',
  data: () => {
    return {
      name: '',
      motto: '',
      motto_english: '',
      address: '',
      address_english: '',
      phone_number_1: '',
      phone_number_2: '',
      bank_name: '',
      bank_name_english: '',
      beneficiary_name: '',
      iban: '',
      email: '',
      website: '',
      notes: '',
      vat: '',
      vat_english: '',
      doy: '',
      showMessage: false,
      alertIsShown: false,
      message: '',
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      logo_url: '',
      logoExists: false,
      logo: '',
      // signature_url: '',
      signatureExists: false,
      signature: '',
      bank_accounts: '',
      bank_accounts_english: '',
      editorOption: {
          theme: 'bubble',
          placeholder: "Η διεύθυνση της εταιρείας",
          modules: {
            toolbar: [
              ['clean']
            ]
          }
        },
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    deleteLogo() {
      let self = this
      this.deleteFile(this.logo).then((response) => {
        console.log("here");
        if (response == 'success') {
          console.log("here");
          self.logoExists = false;
          self.logo = '';
          self.logo_url = '';
        }
      });
    },
    // deleteSignature() {
    //   let self = this
    //   this.deleteFile(this.signature).then((response) => {
    //     console.log("here");
    //     if (response == 'success') {
    //       self.signatureExists = false;
    //       self.signature = '';
    //       self.signature_url = '';
    //     }
    //   });
    // },
    async deleteFile(file){
        let self = this
        let response = await axios.post( '/api/companyInfo/deleteFile?company_id=1&id=' + file.id + '&token=' + localStorage.getItem("api_token")
        ).then(function(){
          return 'success';
        })
        .catch(function(error){
            console.log(error)
            self.$router.push({ path: '/login' })
            return 'error';
        });
        return response;
    },
    handleFileUpload(files, field_type) {
        let self = this;
        let formData = new FormData();
        formData.append('file', files[0]);
        formData.append('field_type', field_type);
        axios.post( '/api/companyInfo/addFile?id=1&token=' + localStorage.getItem("api_token"),
            formData,
            { headers: {
                'Content-Type': 'multipart/form-data'
            }}
        ).then(function(response){
          if (field_type == 'logo') {
            self.logo = response.data.media;
            self.logo_url = self.logo.url;
            if (self.logo_url) {
              self.logoExists = true;
            }
          } //else {
          //   self.signature = response.data.media;
          //   self.signature_url = self.signature.url;
          //   if (self.signature_url) {
          //     self.signatureExists = true;
          //   }
          // }
        })
        .catch(function(error){
            console.log(error)
            self.$router.push({ path: '/login' })
        });
    },
    update() {
      let self = this;
      axios.post('/api/companyInfo/1?token=' + localStorage.getItem("api_token"),
      {
          _method: 'PUT',
          name: self.name,
          motto: self.motto,
          motto_english: self.motto_english,
          address: self.address,
          address_english: self.address_english,
          phone_number_1: self.phone_number_1,
          phone_number_2: self.phone_number_2,
          bank_accounts: self.bank_accounts,
          bank_accounts_english: self.bank_accounts_english,
          email: self.email,
          website: self.website,
          notes: self.notes,
          vat: self.vat,
          vat_english: self.vat_english,
          doy: self.doy,
      })
      .then(function (response) {
          self.message = 'Επιτυχής επεξεργασία στοιχείων εταιρείας.';
          self.showAlert();
      }).catch(function (error) {
          if(error.response.data.message == 'The given data was invalid.'){
            self.message = '';
            for (let key in error.response.data.errors) {
              if (error.response.data.errors.hasOwnProperty(key)) {
                self.message += error.response.data.errors[key][0] + '  ';
              }
            }
            self.showAlert();
          }else{
            console.log(error.response.data.message);
            console.log(error);
            // self.$router.push({ path: '/login' }); 
          }
      });
    },
    getCompanyInfo() {
      let self = this;
      axios.get('/api/companyInfo/1?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.name = response.data.companyInfo.name
        self.motto = response.data.companyInfo.motto
        self.motto_english = response.data.companyInfo.motto_english
        self.address = response.data.companyInfo.address
        self.address_english = response.data.companyInfo.address_english
        self.phone_number_1 = response.data.companyInfo.phone_number_1
        self.phone_number_2 = response.data.companyInfo.phone_number_2
        self.bank_accounts = response.data.companyInfo.bank_accounts
        self.bank_accounts_english = response.data.companyInfo.bank_accounts_english
        self.email = response.data.companyInfo.email
        self.website = response.data.companyInfo.website
        self.notes = response.data.companyInfo.notes
        self.vat = response.data.companyInfo.vat
        self.vat_english = response.data.companyInfo.vat_english
        self.doy = response.data.companyInfo.doy
        
        self.logo = response.data.companyInfo.media.find((item) => item.custom_properties.field_type == "logo");
        if (self.logo) {
          self.logo_url = self.logo.url;
          self.logoExists = true;
        }

        // self.signature = response.data.companyInfo.media.find((item) => item.custom_properties.field_type == "signature");
        // if (self.signature) {
        //   self.signature_url = self.signature.url;
        //   self.signatureExists = true;
        // }
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      }); 
    },
  },
  mounted: function(){
    let self = this;
    self.getCompanyInfo();
  }
}

</script>
